<template>
  <div>
    <b-card>
      <b-card-header>
        <b-card-title class="mb-0">Training Overview</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-card class="filter-panel mb-2">
          <b-row>
            <b-col cols="12" md="4" lg="2" class="mb-1">
              <label class="filter-label">Year</label>
              <b-form-input type="number" v-model.number="filters.year" @change="loadOverview" :min="2000" :max="2099" />
            </b-col>
            <b-col cols="12" md="4" lg="2" class="mb-1">
              <label class="filter-label">Companies</label>
              <v-select :options="companies" :multiple="true" label="label" v-model="filters.company" @input="loadOverview" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllCompanies">Select All</b-button>
            </b-col>
            <b-col cols="12" md="4" lg="2" class="mb-1">
              <label class="filter-label">Courses</label>
              <v-select :options="courses" :multiple="true" label="label" v-model="filters.course" @input="loadOverview" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllCourses">Select All</b-button>
            </b-col>
            <b-col cols="12" md="4" lg="2" class="mb-1">
              <label class="filter-label">Sites</label>
              <v-select :options="filteredSites" :multiple="true" label="label" v-model="filters.site" @input="loadOverview" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllSites">Select All</b-button>
            </b-col>
            <b-col cols="12" md="4" lg="2" class="mb-1">
              <label class="filter-label">Roles</label>
              <v-select :options="roles" :multiple="true" label="label" v-model="filters.role" @input="loadOverview" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllRoles">Select All</b-button>
            </b-col>
            <b-col cols="12" md="4" lg="2" class="mb-1">
              <label class="filter-label">Users</label>
              <v-select :options="filteredUsers" :multiple="true" label="label" v-model="filters.user" @input="loadOverview" placeholder="All" />
              <b-button size="sm" variant="link" class="p-0 mt-25" @click="selectAllUsers">Select All</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ kpis.total_events_this_year || 0 }}</div>
              <small class="text-muted">Total Events (This Year)</small>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ kpis.total_participants || 0 }}</div>
              <small class="text-muted">Total Participants</small>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ formatPercent(kpis.average_attendance_rate) }}</div>
              <small class="text-muted">Average Attendance Rate</small>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ kpis.total_companies_participating || 0 }}</div>
              <small class="text-muted">Total Companies Participating</small>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h5 mb-0">{{ kpis.top_course_by_attendance || '-' }}</div>
              <small class="text-muted">Top Course (by attendance)</small>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import reportStoreModule from './reportStoreModule'
import vSelect from "vue-select";

export default {
    components: {
      vSelect,
    },
  name: 'TrainingOverview',
  data() {
    return {
      kpis: {},
      companies: [],
      courses: [],
      sites: [],
      roles: [],
      users: [],
      filters: {
        year: new Date().getFullYear(),
        company: [],
        course: [],
        site: [],
        role: [],
        user: [],
      },
    }
  },
  computed: {
    filteredSites() {
      const ids = (this.filters.company || []).map(c => c.id)
      if (!ids.length) return this.sites
      return this.sites.filter(s => ids.includes(s.company_id))
    },
    filteredUsers() {
      const ids = (this.filters.company || []).map(c => c.id)
      if (!ids.length) return this.users
      return this.users.filter(u => ids.includes(u.company_id))
    },
  },
  created() {
    const MODULE = 'trainingReports'
    if (!store.hasModule(MODULE)) store.registerModule(MODULE, reportStoreModule)
    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE)
    })
    this.loadOptions().then(this.loadOverview)
  },
  methods: {
    loadOptions() {
      return store.dispatch('trainingReports/getTrainingOptions').then(res => {
        this.companies = res.data.companies || []
        this.courses = res.data.courses || []
        this.sites = res.data.sites || []
        this.roles = res.data.roles || []
        this.users = res.data.users || []
      })
    },
    selectAllCompanies() {
      this.filters.company = (this.companies || []).slice()
      this.loadOverview()
    },
    selectAllCourses() {
      this.filters.course = (this.courses || []).slice()
      this.loadOverview()
    },
    selectAllSites() {
      this.filters.site = this.filteredSites.slice()
      this.loadOverview()
    },
    selectAllRoles() {
      this.filters.role = (this.roles || []).slice()
      this.loadOverview()
    },
    selectAllUsers() {
      this.filters.user = this.filteredUsers.slice()
      this.loadOverview()
    },
    loadOverview() {
      const params = this.buildParams({ year: this.filters.year })
      store.dispatch('trainingReports/getTrainingOverview', params).then(res => {
        this.kpis = res.data.kpis || {}
      }).catch(err => {
        this.$swal({ title: 'Error', text: 'Failed to load overview: ' + err, icon: 'error' })
      })
    },
    buildParams(extra = {}) {
      const company_id = (this.filters.company || []).map(c => c.id).join(',') || undefined
      const course_id = (this.filters.course || []).map(c => c.id).join(',') || undefined
      const site_id = (this.filters.site || []).map(s => s.id).join(',') || undefined
      const role = (this.filters.role || []).map(r => r.id).join(',') || undefined
      const user_id = (this.filters.user || []).map(u => u.id).join(',') || undefined
      return { ...extra, company_id, course_id, site_id, role, user_id }
    },
    formatPercent(v) {
      if (v === null || v === undefined) return '0%'
      return `${Number(v).toFixed(2)}%`
    },
  },
}
</script>

<style scoped>
.h4 { font-weight: 600; }
.filter-panel { background: #f8f8f8; }
.filter-label { font-size: 0.75rem; font-weight: 600; text-transform: uppercase; color: #6e6b7b; margin-bottom: 0.25rem; display: block; }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

